import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './index.scss';

class ChannelTitle extends Component {
  static propTypes = {
    icon: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
  };

  render() {
    const wrapperStyle = {
      backgroundColor: this.props.color,
    };
    return (
      <div className="ChannelTitle">
        <div>
          <div className="ChannelTitle-icon-wrapper" style={wrapperStyle}>
            <i className={`${this.props.icon}`}></i>
          </div>
        </div>
        <span>{this.props.name}</span>
      </div>
    );
  }
}

export default ChannelTitle;
